const themeColor = () => {
  const mainColor = () => {
    return "#3ACAC9"
  }
  const mainBgColor = () => {
    return "#E9F9F8"
  }
  const syounikaPrimaryColor = () => {
    return "#FF6B7F"
  }
  const syounikaBgColor = () => {
    return "#FFF3F4"
  }
  const obstetricsPrimaryColor = () => {
    return "#69B72E"
  }

  const obstetricsBgColor = () => {
    return "#F3FCED"
  }

  return {
    mainColor,
    mainBgColor,
    syounikaPrimaryColor,
    syounikaBgColor,
    obstetricsPrimaryColor,
    obstetricsBgColor
  }
}

export { themeColor }
